import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatSort } from '@angular/material/sort';
import { DataBagService } from '../../../common/data-bag.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';

export interface PeriodicElement {
	name: string;
	weight: number;
	symbol: string;
}

@Component({
	selector: 'app-www-menu-list',
	templateUrl: './www-menu-list.component.html',
	styleUrls: ['./www-menu-list.component.css'],
})
export class WwwMenuListComponent implements OnInit {
	@ViewChild('dataTable') table: MatTable<PeriodicElement>;
	@ViewChild(MatSort) sort: MatSort;

	displayedColumns: string[] = ['id', 'name', 'isActive', 'link', 'edit'];
	data: MatTableDataSource<PeriodicElement> = new MatTableDataSource<PeriodicElement>();
	menu: Array<any> = [];

	constructor(
		private readonly bag: DataBagService,
		private readonly infobox: InfoboxService,
	) {}

	ngOnInit(): void {
		this.bag.get('/www/menu/?limit=150', (result, error) => {
			this.data.data = result.results
				.filter((obj) => obj.parentMenu === null)
				.map((obj) => {
					obj.status = obj.isActive == true ? 'Aktywny' : 'Nieaktywny';
					return obj;
				});
		});
	}

	dropTable(event: CdkDragDrop<PeriodicElement[]>): void {
		moveItemInArray(this.data.data, event.previousIndex, event.currentIndex);
		this.table.renderRows();
	}

	save(data) {
		data.data.forEach((element, id) => {
			if (element.order !== id) {
				if (!!element.multimedia) {
					element.multimedia = element.multimedia.id;
				}
				element.order = id;
				this.bag.put('/www/menu/' + element.id + '/', element, (result, error) => {
					if (error) {
						return;
					}
					this.infobox.success('Zapisano');
				});
			}
		});
	}
}
